import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'



export function getCompanyList(params, isNotify) {
  let isTest = false
  if (isTest) {
  return new Promise(function(resolve, reject) {
    let res = { list: [] }
      companyData.list.forEach(item => {
          res.push(item)
      })
      resolve(res.list)
    })
  }
  return request({
    url: `/api/getCompanyList`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
  
export function getCompanyData(param) {
  let isTest = false
  let data =param
  if (isTest) {
  return new Promise(function(resolve, reject) {
    let res = { list: [] }
      companyData.list.forEach(item => {
        if(item.clntId === param || param == null)
          res.list.push(item)
      })
      resolve(res)
    })
  }
  return request({
    url: `/api/getCompanyData`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data:param
  })
}


export function saveCompany(param,isNotify) {
  return request({
    url: `/api/saveCompany`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteCompany(param,isNotify) {
  return request({
    url: `/api/deleteCompany`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}
